var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.531 5.606a.525.525 0 1 1 .525-.526.528.528 0 0 1-.525.526zM.525 3.7A.525.525 0 0 1 0 3.177V.525a.525.525 0 0 1 1.05 0v2.652a.526.526 0 0 1-.525.523z",
    transform: "translate(5.472 3.201)",
    style: {
      fill: "#531616"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAlert);
export default __webpack_public_path__ + "static/media/circle-alert.1ddafe115a7bb9a35d8b936ab5bffcb6.svg";
export { ForwardRef as ReactComponent };